// Recovered compiled webpack factory 11807. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      createMutableActionQueue: function () {
        return _;
      },
      dispatchNavigateAction: function () {
        return y;
      },
      dispatchTraverseAction: function () {
        return v;
      },
      getCurrentAppRouterState: function () {
        return m;
      },
      publicAppRouterInstance: function () {
        return b;
      },
    }));
  let n = r(86871),
    a = r(68451),
    o = r(12115),
    i = r(54089);
  r(66048);
  let s = r(76248),
    l = r(96058),
    u = r(17297),
    c = r(43933),
    f = r(63499);
  function d(e, t) {
    null !== e.pending &&
      ((e.pending = e.pending.next),
      null !== e.pending
        ? p({ actionQueue: e, action: e.pending, setState: t })
        : e.needsRefresh &&
          ((e.needsRefresh = !1),
          e.dispatch({ type: n.ACTION_REFRESH, origin: window.location.origin }, t)));
  }
  async function p(e) {
    let { actionQueue: t, action: r, setState: n } = e,
      a = t.state;
    t.pending = r;
    let o = r.payload,
      s = t.action(a, o);
    function l(e) {
      r.discarded || ((t.state = e), d(t, n), r.resolve(e));
    }
    (0, i.isThenable)(s)
      ? s.then(l, (e) => {
          (d(t, n), r.reject(e));
        })
      : l(s);
  }
  let h = null;
  function _(e, t) {
    let r = {
      state: e,
      dispatch: (e, t) =>
        (function (e, t, r) {
          let a = { resolve: r, reject: () => {} };
          if (t.type !== n.ACTION_RESTORE) {
            let e = new Promise((e, t) => {
              a = { resolve: e, reject: t };
            });
            (0, o.startTransition)(() => {
              r(e);
            });
          }
          let i = { payload: t, next: null, resolve: a.resolve, reject: a.reject };
          null === e.pending
            ? ((e.last = i), p({ actionQueue: e, action: i, setState: r }))
            : t.type === n.ACTION_NAVIGATE || t.type === n.ACTION_RESTORE
              ? ((e.pending.discarded = !0),
                (i.next = e.pending.next),
                e.pending.payload.type === n.ACTION_SERVER_ACTION && (e.needsRefresh = !0),
                p({ actionQueue: e, action: i, setState: r }))
              : (null !== e.last && (e.last.next = i), (e.last = i));
        })(r, e, t),
      action: async (e, t) => (0, a.reducer)(e, t),
      pending: null,
      last: null,
      onRouterTransitionStart:
        null !== t && "function" == typeof t.onRouterTransitionStart
          ? t.onRouterTransitionStart
          : null,
    };
    if (null !== h)
      throw Object.defineProperty(
        Error("Internal Next.js Error: createMutableActionQueue was called more than once"),
        "__NEXT_ERROR_CODE",
        { value: "E624", enumerable: !1, configurable: !0 },
      );
    return ((h = r), r);
  }
  function m() {
    return null !== h ? h.state : null;
  }
  function g() {
    return null !== h ? h.onRouterTransitionStart : null;
  }
  function y(e, t, r, a) {
    let o = new URL((0, l.addBasePath)(e), location.href);
    (0, f.setLinkForCurrentNavigation)(a);
    let i = g();
    (null !== i && i(e, t),
      (0, s.dispatchAppRouterAction)({
        type: n.ACTION_NAVIGATE,
        url: o,
        isExternalUrl: (0, u.isExternalURL)(o),
        locationSearch: location.search,
        shouldScroll: r,
        navigateType: t,
        allowAliasing: !0,
      }));
  }
  function v(e, t) {
    let r = g();
    (null !== r && r(e, "traverse"),
      (0, s.dispatchAppRouterAction)({ type: n.ACTION_RESTORE, url: new URL(e), tree: t }));
  }
  let b = {
    back: () => window.history.back(),
    forward: () => window.history.forward(),
    prefetch: (e, t) => {
      let r = (function () {
          if (null === h)
            throw Object.defineProperty(
              Error("Internal Next.js error: Router action dispatched before initialization."),
              "__NEXT_ERROR_CODE",
              { value: "E668", enumerable: !1, configurable: !0 },
            );
          return h;
        })(),
        a = (0, u.createPrefetchURL)(e);
      if (null !== a) {
        var o;
        (0, c.prefetchReducer)(r.state, {
          type: n.ACTION_PREFETCH,
          url: a,
          kind: null != (o = null == t ? void 0 : t.kind) ? o : n.PrefetchKind.FULL,
        });
      }
    },
    replace: (e, t) => {
      (0, o.startTransition)(() => {
        var r;
        y(e, "replace", null == (r = null == t ? void 0 : t.scroll) || r, null);
      });
    },
    push: (e, t) => {
      (0, o.startTransition)(() => {
        var r;
        y(e, "push", null == (r = null == t ? void 0 : t.scroll) || r, null);
      });
    },
    refresh: () => {
      (0, o.startTransition)(() => {
        (0, s.dispatchAppRouterAction)({ type: n.ACTION_REFRESH, origin: window.location.origin });
      });
    },
    hmrRefresh: () => {
      throw Object.defineProperty(
        Error("hmrRefresh can only be used in development mode. Please use refresh instead."),
        "__NEXT_ERROR_CODE",
        { value: "E485", enumerable: !1, configurable: !0 },
      );
    },
  };
  (window.next && (window.next.router = b),
    ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
      void 0 === t.default.__esModule &&
      (Object.defineProperty(t.default, "__esModule", { value: !0 }),
      Object.assign(t.default, t),
      (e.exports = t.default)));
}
